import { useState } from "react";
import { PhoneNav } from "../../shared/phone/PhoneNav";
import { ActionSheet } from "../../shared/phone/Sheet";
import { usePartnerAuth } from "../context/PartnerAuthContext";
import { EmptyBlock, PoweredBy, ProgramRow, useOpenProgram } from "../components/phone/parts";

/**
 * Every program the partner is invited to, with its state; tap one to show it, or to start its setup. From
 * Account it is a pushed screen; before a program is picked it is the first screen, with Log out at its foot.
 */
export function ProgramsNative({ fromAccount }: { fromAccount: boolean }) {
  const { session, selectedProgramId, logout } = usePartnerAuth();
  const openProgram = useOpenProgram();
  const [confirmOut, setConfirmOut] = useState(false);
  const programs = session?.programs ?? [];

  return (
    <div className="pn-screen">
      <PhoneNav
        large
        title={fromAccount ? "All programs" : "Your programs"}
        back={fromAccount ? { to: "/profile", label: "Account" } : undefined}
      />
      <div className="pn-stack">
        {programs.length === 0 ? (
          <EmptyBlock icon="grid" title="Nothing to promote yet">
            Programs you are invited to show up here. Ask a program owner for an invite link.
          </EmptyBlock>
        ) : (
          <div className="pn-grp">
            {programs.map((p) => (
              <ProgramRow key={p.programId} p={p} current={p.programId === selectedProgramId} showActive onOpen={() => openProgram(p)} />
            ))}
          </div>
        )}
        {fromAccount ? null : (
          <>
            <div className="pn-grp">
              <button type="button" className="pn-row danger" onClick={() => setConfirmOut(true)}>
                <span className="m">
                  <span className="t">Log out</span>
                </span>
              </button>
            </div>
            <PoweredBy />
          </>
        )}
      </div>
      <ActionSheet
        open={confirmOut}
        onClose={() => setConfirmOut(false)}
        message="You can log back in with your email and password."
        actions={[
          {
            label: "Log out",
            danger: true,
            onSelect: () => void logout().catch(() => {}),
          },
        ]}
      />
    </div>
  );
}
